import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import EditButton from "components/CustomButtons/Button.js";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import { getSite } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { categorypage } from "variables/tertiaryBill";
import { categoriesdata, subcategoriesdata } from "variables/lists/tertiarybill";
import { NotificationManager } from 'react-notifications';
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import moment from "moment";
import uuid from "react-uuid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import AddIcon from "@mui/icons-material/Add";
import CategoryEditionDialog from "./CategoryEditionDialog";
import Dialog from "@mui/material/Dialog";

const useStyles2 = makeStyles(styles);
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;
const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;
const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;


export default function Categories(props) {
  const classes = useStyles();
  const classes2 = useStyles2();

  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [currentCategory, setCurrentCategory] = useState("");
  const [tertiarybill, setTertiarybill] = useState("");
  const [categories, setCategories] = useState([]);
  const [opencategory, setOpencategory] = useState(false);

  const handleEdit = async (categoriestosave) => {
    axios
      .put(
        getSite(chartIdGroup, "tertiarybill"),
        {
          ...tertiarybill,
          categories: categoriestosave
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setOpencategory(false);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setTertiarybill(res.data.detail.tertiarybill || {});
        setCategories(res.data.detail.tertiarybill?.categories || []);
      });
  }, []);



  const categoriescolumns = [
    {
      name: categorypage.category,
      selector: (row) => row.category ? categoriesdata.find((f) => f.id === row.category)?.name : row.category,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.category ? categoriesdata.find((f) => f.id === row.category)?.name : ""
    },
    {
      name: categorypage.subcategory,
      selector: (row) => row.subcategory ? subcategoriesdata.find((f) => f.id === row.subcategory)?.name : row.subcategory,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.subcategory ? subcategoriesdata.find((f) => f.id === row.subcategory)?.name : ""
    },
    {
      name: categorypage.surface,
      selector: (row) => row.surface,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.surface
    },
    {
      name: categorypage.datebegin,
      selector: (row) => row.datebegin,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.datebegin && moment(row.datebegin).isValid()
          ? moment(row.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: categorypage.dateend,
      selector: (row) => row.dateend,
      sortable: true,
      cell: (row) =>
        row.dateend && moment(row.dateend).isValid()
          ? moment(row.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "",
      sortable: false,
      width: "8rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title={categorypage.editcategory}>
              <EditButton
                onClick={editCategory(row)}
                color={"warning"}
                className={classes2.actionButton}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title={categorypage.deletecategory}>
              <CustomDeleteButton
                deleteTitle={"Suppression de la vue"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la catégorie'${row.category}'`}
                handleSupprimer={deleteCategory(row)}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const indicatorscolumns = [
    {
      name: categorypage.indicatorname,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name
    },
    {
      name: categorypage.indicatorvalue,
      selector: (row) => row.value,
      sortable: true,
      cell: (row) => row.value
    }
  ]

  const handleClickOpenCategory = () => {
    setOpencategory(true);
  };
  const handleClickCloseCategory = () => {
    setOpencategory(false);
  };

  const editCategory = (row) => async () => {
    let obj = categories.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentCategory(obj);
      handleClickOpenCategory();
    }
  }
  const deleteCategory = (row) => async () => {
    let obj = categories.find((o) => o.uuid === row.uuid);
    if (obj) {
      let newcategories = [...categories];
      newcategories = newcategories.filter((o) => o.uuid !== row.uuid);
      setCategories(newcategories);
      handleEdit(newcategories);
    }

  };

  const AddCategory = () => {
    setCurrentCategory("");
    handleClickOpenCategory();
  };

  const [filterTextCategory, setFilterTextCategory] = useState("");
  const [resetPaginationToggleCategory, setResetPaginationToggleCategory] = useState(false);
  const SearchComponentCategory = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItemsCategory = categories.filter(
    (item) =>
      (item.category && item.category.toLowerCase().includes(filterTextCategory.toLowerCase())) ||
      (item.subcategory && item.subcategory.toLowerCase().includes(filterTextCategory.toLowerCase())) ||
      (item.category && categoriesdata.find((x) => x.id == item.category) && categoriesdata.find((x) => x.id == item.category).name.toLowerCase().includes(filterTextCategory.toLowerCase())) ||
      (item.subcategory && subcategoriesdata.find((x) => x.id == item.subcategory) && subcategoriesdata.find((x) => x.id == item.subcategory).name.toLowerCase().includes(filterTextCategory.toLowerCase()))
  );
  const subHeaderComponentMemoCategory = useMemo(() => {
    const handleClearCategory = () => {
      if (filterTextCategory) {
        setResetPaginationToggleCategory(!resetPaginationToggleCategory);
        setFilterTextCategory("");
      }
    };
    const onFilterTextCategory = (e) => setFilterTextCategory(e.target.value);

    return (
      <>
        <TableName></TableName>
        <SearchComponentCategory
          key="SearchComponentCategory"
          onFilter={onFilterTextCategory}
          onClear={handleClearCategory}
          filterText={filterTextCategory}
        />

        <UploadButton type="button" onClick={handleClearCategory}>
          <Tooltip title="Ajouter une vue">
            <Button
              onClick={AddCategory}
              color={"success"}
              className={classes2.actionButton}
            >
              <AddIcon fontSize="large" />
            </Button>
          </Tooltip>
        </UploadButton>

      </>
    );
  }, [filterTextCategory, resetPaginationToggleCategory, categories, currentCategory]);

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = data.indicators;

    return (
      <Container>
        <ExpandableContainer>
          <ExpandableElement>
            <ElementTitle>{categorypage.heating} : </ElementTitle>
            <ElementData>{data.heating ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.cooling} : </ElementTitle>
            <ElementData>{data.cooling ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.coollog} : </ElementTitle>
            <ElementData>{data.coollog ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.coolcom} : </ElementTitle>
            <ElementData>{data.coolcom ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.consdoc} : </ElementTitle>
            <ElementData>{data.consdoc ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
        </ExpandableContainer>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun indicateur à afficher</NoData>}
          noHeader={true}
          columns={indicatorscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
          dense
        />
      </Container>
    );
  };


  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <DataTable
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            noDataComponent={<NoData>{"Aucune catégorie"}</NoData>}
            noHeader={true}
            columns={categoriescolumns}
            persistTableHead
            pagination
            subHeader
            data={filteredItemsCategory}
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            defaultPageSize={10}
            filterable={true}
            defaultSortFieldId={1}
            manual={true}
            paginationResetDefaultPage={resetPaginationToggleCategory}
            subHeaderComponent={subHeaderComponentMemoCategory}
            expandOnRowClicked
            expandableRows
            expandableRowDisabled={(row) => row.disabled}
            expandableRowsComponent={ExpandableComponent}
          />
        </GridItem>

      </GridContainer>
      <Dialog
        onClose={handleClickCloseCategory}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={opencategory}
      >
        <CategoryEditionDialog
          currentCategory={currentCategory}
          closeModal={handleClickCloseCategory}
          categories={categories}
          setCategories={setCategories}
          handleEdit={handleEdit}
        // refetch={refreshTableView}
        />
      </Dialog>
    </div>
  );
}
